const byteToHex: string[] = [];
for (let i = 0; i < 256; i += 1) {
  byteToHex[i] = (i + 0x100).toString(16).slice(1);
}

export const getRandomHex = (bytes = 16): string => {
  const uintArray = new Uint8Array(bytes);
  if (!crypto.getRandomValues) {
    return '';
  }

  const buffer = crypto.getRandomValues(uintArray);
  return [...buffer].map((v) => byteToHex[v]).join('');
};

export default getRandomHex;
